<template>
  <div class="top-op-container">
    <div class="banner-topo"></div>
    <div class="grid-wrapper">
    <div class="opcoes-grid">
      <div class="opcao-item" @click="HorasExtras">
        <p class="opcao-texto">Horas Extras</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>

      <div class="opcao-item" @click="AdicionalNoturno">
        <p class="opcao-texto">Adicional Noturno</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>

      <div class="opcao-item" @click="RemuneracaoFerias">
        <p class="opcao-texto">Remuneração de Férias</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>

      <div class="opcao-item" @click="FaltasAfastamentos">
        <p class="opcao-texto">Férias: Faltas e Afastamento</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>

      <div class="opcao-item" @click="RecisaoContrato">
        <p class="opcao-texto">Rescisão de Contrato de Trabalho</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>
      
      <div class="opcao-item" @click="CustoFuncionario">
        <p class="opcao-texto">Custo do Empregado</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>

      <div class="opcao-item" @click="CalculoAtestados">
        <p class="opcao-texto">Cálculo de Atestados</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>
      <div class="opcao-item" @click="CalculoSeguroDesemprego">
        <p class="opcao-texto">Cálculo Seguro Desemprego</p>
        <div class="opcao-bolha">
          <img src="../assets/arrow.svg" alt="Seta" />
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      atual: null,
    };
  },
  methods: {
    CustoFuncionario() {
      this.atual = 6;
      this.$router.push({ name: "custoFuncionario", params: { id: 5 } });
    },
    HorasExtras() {
      this.atual = 1;
      this.$router.push({ name: "horasExtras", params: { id: 1 } });
    },
    RecisaoContrato() {
      this.atual = 5;
      this.$router.push({ name: "contratotrabalho", params: { id: 5 } });
    },
    AdicionalNoturno() {
      this.atual = 2;
      this.$router.push({ name: "adicionalNoturno", params: { id: 2 } });
    },
    RemuneracaoFerias() {
      this.atual = 3;
      this.$router.push({ name: "remuneracaoFerias", params: { id: 3 } });
    },
    FaltasAfastamentos() {
      this.atual = 4;
      this.$router.push({ name: "faltasAfastamentos", params: { id: 4 } });
    },
    CalculoAtestados() {
      this.atual = 7;
      this.$router.push({ name: "calculoAtestado", params: { id: 7 } });
    },
    CalculoSeguroDesemprego() {
      this.atual = 8;
      this.$router.push({ name: "calculoSeguroDesemprego", params: { id: 8 } });
    }
  },
  mounted() {
    this.atual = this.$route.params.id;
  },
};
</script>

<style scoped>

.top-op-container {
  position: relative;
  width: 100%;
  margin-bottom: 80px;
}

.banner-topo {
  background-image: url("https://www.lefisc.com.br/calculos/static/img/bannertop.jpg");
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
}

.grid-wrapper {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -80px;

  padding: 0 20px;
  box-sizing: border-box;
}

.opcoes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 5px;
}

.opcao-item {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  min-height: 125px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
  text-align: center;
}

.opcao-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

.opcao-texto {
  font-size: 17px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 15px;
  color: #333;
}

.opcao-bolha {
  background-color: #f7b733;
  height: 45px;
  width: 45px;
  border-radius: 50%;
  
  display: flex;
  justify-content: center;
  align-items: center;
}

.opcao-bolha img {
  width: 20px;
}
</style>


// WEBPACK FOOTER //
// src/shared/topOp.vue